import { MutationTree } from 'vuex'
import _get from 'lodash/get'

import { Book, Condition, GuidePrice } from '@/types'
import { BooksState } from './types'
import { state as initialState } from './index'

export const mutations: MutationTree<BooksState> = {
  reset(state) {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key]
    })
  },
  resetRequest(state) {
    Object.keys(initialState).forEach(key => {
      if (key.indexOf('request') === 0 || key === 'error') {
        state[key] = initialState[key]
      }
    })
  },
  setSearchKeyword(state, payload: string) {
    state.searchKeyword = payload
  },
  setBestBook(state, payload: Book) {
    state.bestBook = payload
    state.activeGuidePrice = _get(payload, ['guidePrices', 0]) || null
    state.requestSearchBook = false
  },
  setConditions(state, payload: { conditions: Condition[]; offset: number }) {
    state.conditions = !payload.offset
      ? payload.conditions || []
      : [...state.conditions, ...payload.conditions]
    state.requestGetConditions = false
    state.error = null
  },
  setGuidPrices(state, payload: { guidePrices: GuidePrice[]; offset: number }) {
    if (state.bestBook) {
      state.bestBook = {
        ...state.bestBook,
        guidePrices: !payload.offset
          ? payload.guidePrices || []
          : [...(state.bestBook.guidePrices || []), ...payload.guidePrices],
      }
    }
    state.activeGuidePrice = _get(payload, ['guidePrices', 0]) || null
    state.requestGetGuidePrices = false
    state.error = null
  },

  setActiveGuidePrice(state, payload: GuidePrice) {
    state.activeGuidePrice = payload
  },
  setError(state, payload) {
    state.error = payload
    state.requestSearchBook = false
  },
  setRequestSearchBook(state, payload: boolean) {
    state.requestSearchBook = payload
    state.error = null
  },
  setRequestGetGuidePrices(state, payload: boolean) {
    state.requestGetGuidePrices = payload
    state.error = null
  },
}
